import { useRef, useEffect } from 'react';
/**
 *
 * useOnWindowScroll hook
 *
 * Fires a callback when window scroll
 *
 * @param {function} callback Callback to be called before unmount
 * @param {boolean} when When the handler should be applied
 */

function useOnWindowScroll(callback) {
  var when = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var savedHandler = useRef(callback);
  useEffect(function () {
    return savedHandler.current = callback;
  });
  useEffect(function () {
    if (when) {
      window.addEventListener("scroll", savedHandler.current);
      return function () {
        return window.removeEventListener("scroll", savedHandler.current);
      };
    }
  }, [when]);
}

export default useOnWindowScroll;